import { useContext } from 'react';

import { AuthenticationContext } from './AuthenticationProvider';

import type { Context } from './AuthenticationProvider';

type UseAuthContext = {
  checkLoginAndOpenAuthDialog: (
    callBack: () => void,
    title: string,
    successRedirectUrl?: string
  ) => void;
} & Context;

export const useAuthenticationContext = (): UseAuthContext => {
  const authContext = useContext(AuthenticationContext);
  const { isUserLoggedIn, openAuthDialog } = authContext;

  const checkLoginAndOpenAuthDialog = (
    callBack: () => void,
    title: string,
    successRedirectUrl?: string
  ): void => {
    if (!isUserLoggedIn) {
      openAuthDialog({ title, successRedirectUrl });
      return;
    }

    callBack();
  };

  return {
    checkLoginAndOpenAuthDialog,
    ...authContext,
  };
};
